import truncate from "truncate-html";

import findNearest from "../findNearest";

const rangeStartIndex = (limit, threshold) => {
  if (limit - threshold < 0) {
    return 0;
  }

  return limit - threshold - 1;
};

const rangeEndIndex = (limit, threshold, textLength) => {
  if (limit + threshold > textLength) {
    return textLength - 1;
  }

  return limit + threshold;
};

const tokenInRange = (text, rangeStart, rangeEnd, token) =>
  text.slice(rangeStart, rangeEnd).indexOf(token) > -1;

export default (rawString, limit, threshold = 0) => {
  /**
   * Get text stripped of HTML tags. We'll use this to determine if a
   * string has an end of sentence or end of word within a reasonable
   * distance of our limit.
   */
  const text = truncate(rawString, rawString.length, { stripTags: true });

  if (text.length <= limit) return rawString;

  const rangeStart = rangeStartIndex(limit, threshold);

  const rangeEnd = rangeEndIndex(limit, threshold, text.length);

  const canTruncateAtEndOfSentence = tokenInRange(
    text,
    rangeStart,
    rangeEnd,
    "."
  );

  if (canTruncateAtEndOfSentence) {
    const endOfNearestSentence = findNearest(text, limit, ".");

    return truncate(rawString, endOfNearestSentence + 1, {
      ellipsis: ""
    });
  }

  const canTruncateAtEndOfWord = tokenInRange(text, rangeStart, rangeEnd, " ");

  if (canTruncateAtEndOfWord) {
    const endOfNearestWord = findNearest(text, limit, " ");

    return truncate(rawString, endOfNearestWord);
  }

  return truncate(rawString, limit);
};
